import React, { Component } from "react";
import { connect } from "react-redux";
import "./index.scss";
class ToasTxt extends Component {
  render() {
    const { props } = this;
    return props.show ? (
      <div onClick={e => e.stopPropagation()}>
        {props.isShowHot && (
          <div
            className="hot_box dis_f ali_ct"
            style={{
              left: props.data.x + "%",
              top: props.data.y + "%"
            }}
            onClick={() => props.onShowHotContent(true)}
          >
            <div className="hot_tag">
              <div className="place_cri1"></div>
              <div className="place_cri2"></div>
              <div className="place_cri3"></div>
            </div>
            <div className="hot_txt">{props.data.txt}</div>
          </div>
        )}
        {/* 热点内容 */}
        {props.isShowHotContent && (
          <div className="toast_bg">
            <img
              onClick={() => props.onShowHotContent(false)}
              src={require("@img/close.png")}
              className={`close_hot ${
                props.videoFullScreen
                  ? props.isHuawei
                    ? "add_ttop"
                    : "add_top"
                  : ""
              }`}
            />
            <div className="hot_content">
              <div className="hot_top_title">{props.data.txt}</div>
              <div
                className="hot_msg"
                dangerouslySetInnerHTML={{ __html: props.data.msg }}
              ></div>
            </div>
          </div>
        )}
      </div>
    ) : null;
  }
}
const mapStateToProps = state => {
  return state;
};
export default connect(mapStateToProps, null)(ToasTxt);
